import { render, staticRenderFns } from "./EventoForm.vue?vue&type=template&id=3797dd1a"
import script from "./EventoForm.vue?vue&type=script&lang=js"
export * from "./EventoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports